import { enum_ } from 'valibot'

export enum StateMapDisk {
  Cloud = 'cloud',
  IndexedDB = 'idb',
}

export const StateMapDiskSchema = enum_(StateMapDisk, 'Invalid Disk')
